import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './ArchiveBundleDialog.module.css'
import { byDesign } from '@/infra/design'
import imgArchiveItemUrl from '@/assets/misc/img_archive-item.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface ArchiveBundleDialogProps {
  showing: boolean
  onClose: () => unknown
  onArchive: () => unknown
  isArchivePending: boolean
  bundleName: string
  corporateMode: boolean
  testId?: string
}

export function ArchiveBundleDialog({
  showing,
  onClose,
  onArchive,
  isArchivePending,
  bundleName,
  corporateMode,
  testId,
}: ArchiveBundleDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isArchivePending ? undefined : onClose}
    >
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgArchiveItemUrl}
              illustration={byDesign(undefined, DocumentsDisabledIllustration)}
              alt="Archive bundle"
            />
          )}
          <h3 className={styles.title}>You’re about to archive a bundle</h3>
          <p className={styles.description}>
            Are you sure you want to archive the{' '}
            <span className={styles.bundleName}>{bundleName}</span> bundle? All
            future jobs will no longer be able to reference this bundle.
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            isDisabled={isArchivePending}
            onPress={onClose}
            variant="default"
            testId={testId && `${testId}-close-archive-modal`}
          />
          <Button
            label="Archive"
            onPress={onArchive}
            isPending={isArchivePending}
            isDisabled={isArchivePending}
            variant="destructive"
            testId={testId && `${testId}-modal-archive-button`}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
